var exports = {
  "az": "Box__GzQJKv",
  "rl": "CardBaseWithSash__FH73Dm",
  "Ax": "ColumnFrame__eDF0-T",
  "wy": "Box_1__uT5YgA",
};

module.exports = exports;
